import axios from 'axios';
import { POST_ENTRY, API_KEY, POST_ENTRY_IMAGE, FINALISE_ENTRY } from '../../enums';
import { get } from 'lodash';

//const testEntry = {"data":{"id":3463395,"name":"Test entry 1","description":"Description","video_vimeo_url":"","video_youtube_url":"https:\/\/www.example.com","position":"entry","other_info":"","hide":false,"state":"new","history_id":1655,"profile_id":1736443,"placing_id":null,"category_id":324,"institution_id":null,"created_at":"2022-06-21T08:35:36.000000Z","updated_at":"2022-06-21T08:35:36.000000Z","rating":null,"duplicate":false,"highres":null},"message":"Ok","code":1,"debug":{"hostname":"uat-1","time":1655800536.267799,"core":[]},"version":"1.13.0-8-gb7a5506"};

export const submitEntry = async (entry, loginState, category_id) => {

  const {entry_name, video, description, thumbnail,
    ai_assisted,
    ai_assisted_how,
    video_make,
    video_model,
    course_name,
    tutors_name,
    tutors_email,
    video_password,
    school_country,
    bio,
    institution_name, autoentries, file_url } = entry;
  const profile = loginState.profiles.data[0];
  const { token } = loginState;
  const formData = new FormData();
  
  const params = {
    name: entry_name, 
    description: description, 
    other_info: '', 
    hide: 0, 
    state: 'new', 
    //profile_id: profile.id, 
    profile: [{
      id: profile.id,
      bio
    }],
    category_id: category_id, 
    history_id: 1655, 
    video_youtube_url: video, 
    video_vimeo_url: '',
    api: API_KEY,
    institution_id: get(entry, 'institution', 0),
    ai_assisted: ai_assisted === 'true',
    ai_assisted_how: ai_assisted_how,
    video_make,
    video_model,
    course_name,
    tutors_name,
    tutors_email,
    video_password,
    school_country,
    bio,
    autoentered: autoentries === null ? null : Object.entries(autoentries).filter(([_, value]) => value).map(([key]) => Number(key)),
    file_url
  }

  if (institution_name && get(entry, 'institution', 0) === 0) {
    params.institution = [{institution_name, country_id: school_country}]
  }

  const response = await axios({
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: POST_ENTRY,
    method: 'POST',
    data: params
  }).catch((error) => {
    throw error;
  })

  //add the thumbnail to the entry
  if (get(response, 'data.data.id')) {

    formData.append('name', thumbnail.name);
    formData.append('image', thumbnail, thumbnail.name);
    formData.append('alt', entry_name);
    formData.append('hide', 0);
    formData.append('rejected', 0);
    formData.append('draft', 1);
    formData.append('entry_id', response.data.data.id);
    formData.append('api', API_KEY);
    

    await axios({
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: POST_ENTRY_IMAGE,
      method: 'POST',
      data: formData
    }).catch((error) => {
      throw error;
    });

    const finaliseResponse = await(axios({
      headers: {
        Authorization: `Bearer ${token}`
      },
      method: 'PATCH',
      url: FINALISE_ENTRY(response.data.data.id),
      data: {
        state: 'complete'
      }
    })).catch((error) => {
      throw error;
    });

    return finaliseResponse;

  }
}